export var TEXT_INDENT = 4;
export var TEXT_INDENT_NARROW = 2;
export var SEPARATED_INPUT_PADDING = 12;
export default (function (_ref) {
  var colors = _ref.colors,
      sizes = _ref.sizes;
  return {
    container: {
      marginLeft: '10px',
      lineHeight: '30px'
    },
    disabled: {
      opacity: '0.6',
      cursor: 'not-allowed'
    },
    fieldGroup: {
      display: 'inline-block'
    },
    char: {
      fontSize: '16px',
      letterSpacing: '7px',
      fontWeight: 300,
      fontFamily: 'monospace'
    },
    charSmall: {
      letterSpacing: '3px'
    },
    input: {
      display: 'inline-block',
      padding: 0,
      color: colors.inputColor,
      borderStyle: 'none',
      outline: 'none',
      appearance: 'none',
      borderRadius: 0,
      backgroundColor: 'transparent',
      transition: 'border-color .2s',
      textIndent: "".concat(TEXT_INDENT, "px"),
      lineHeight: '18px'
    },
    inputSmall: {
      textIndent: "".concat(TEXT_INDENT_NARROW, "px")
    },
    multiLabel: {
      position: 'absolute',
      zIndex: 1,
      top: 0,
      color: colors.monotone3,
      pointerEvents: 'none',
      transition: 'top 0.2s, font-size 0.2s',
      fontWeight: 300,
      fontSize: '11px'
    },
    separatedInput: {
      marginRight: '8px',
      padding: "0px ".concat(SEPARATED_INPUT_PADDING, "px"),
      color: 'hsl(0, 0%, 30%)',
      fontWeight: 300,
      borderBottom: "2px solid ".concat(colors.inputBorder),
      outline: 'none',
      transition: 'border-color .2s',
      height: sizes.inputHeight,
      fontSize: '16px',
      textAlign: 'center',
      letterSpacing: 0,
      textIndent: 0,
      background: colors.white,
      '&:focus': {
        borderColor: colors.primary
      }
    },
    delimiter: {
      fontSize: '16px',
      color: colors.inputBorder,
      margin: '0 8px 0 0'
    },
    teeth: {
      position: 'absolute',
      bottom: 0,
      lineHeight: 0,
      pointerEvents: 'none'
    },
    tooth: {
      display: 'inline-block',
      height: '5px',
      borderLeft: "solid 1px ".concat(colors.inputBorder)
    }
  };
});